@if ({
  options: options$ | async,
  returnsRequest: returnsRequest$ | async,
  }; as content) {
  <div class="simple-card">
    <page-title></page-title>
  </div>
  <div class="simple-card m-t-20">
    <p class="m-b-12 h5">{{ 'return.form.instructions' | cxTranslate }}</p>
    <form [formGroup]="form" (submit)="submit()">
      <div class="row">
        <div class="col-12">
          <h6 class="d-block m-b-12">{{ 'formSearch.searchBy' | cxTranslate }}</h6>
          <div class="form-field-select">
            <div class="form-check form-check-inline">
              <input
                (click)="clearInputValue()"
                type="radio"
                id="searchByOrderDate"
                class="form-check-input"
                formControlName="searchBy"
                value="orderDate"
                />
                <label class="form-check-label" for="searchByOrderDate">{{ 'return.form.orderDate' | cxTranslate }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input type="radio" id="searchByInvoiceNumber" class="form-check-input" formControlName="searchBy" value="invoiceNumber" />
                <label class="form-check-label" for="searchByInvoiceNumber">{{ 'formSearch.invoiceNumber' | cxTranslate }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input type="radio" id="searchByPONumber" class="form-check-input" formControlName="searchBy" value="poNumber" />
                <label class="form-check-label" for="searchByPONumber">{{ 'formSearch.poNumber' | cxTranslate }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input type="radio" id="searchByOrderNumber" class="form-check-input" formControlName="searchBy" value="orderNumber" />
                <label class="form-check-label" for="searchByOrderNumber">{{ 'formSearch.orderNumber' | cxTranslate }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input type="radio" id="searchByPartNumber" class="form-check-input" formControlName="searchBy" value="partNumber" />
                <label class="form-check-label" for="searchByPartNumber">{{ 'formSearch.partNumber' | cxTranslate }}</label>
              </div>
            </div>
          </div>
          @if (form.get('searchBy')?.value === 'orderDate') {
            @if (form.get('searchType')?.value !== 'custom') {
              <div class="col-12 col-md-4 m-t-16">
                <div class="form-group">
                  <span>{{ 'formSearch.selectDateRange' | cxTranslate }}</span>
                  <select class="form-control" formControlName="searchType">
                    <option value="" disabled selected>{{ 'formSearch.selectOption' | cxTranslate }}</option>
                    @for (item of content.options; track item) {
                      <option [attr.aria-label]="item.label" value="{{ item.code }}">
                        {{ item.label }}
                      </option>
                    }
                  </select>
                  <cx-form-errors [control]="form.get('searchType')"></cx-form-errors>
                </div>
              </div>
            } @else {
              <div class="col-12 col-md-4">
                <div class="form-group w custom-date-picker">
                  <div class="d-flex v-center m-b-4">
                    <button type="button" class="btn-back-search-type" (click)="backSearchType()">
                      <span class="material-symbols-outlined d-flex"> arrow_back_ios </span>
                    </button>
                    <label class="m-0" for="fromDate">{{ 'formSearch.from' | cxTranslate }}</label>
                  </div>
                  <p-datepicker
                    formControlName="fromDate"
                    dateFormat="mm/dd/yy"
                    showIcon="true"
                    inputStyleClass="form-control"
                    placeholder="..."
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    allowedKeysToDatePicker
                    >
                  </p-datepicker>
                  <cx-form-errors [control]="form.get('fromDate')"></cx-form-errors>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group custom-date-picker">
                  <label for="toDate">{{ 'formSearch.to' | cxTranslate }}</label>
                  <p-datepicker
                    formControlName="toDate"
                    dateFormat="mm/dd/yy"
                    showIcon="true"
                    inputStyleClass="form-control"
                    placeholder="..."
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    allowedKeysToDatePicker
                    >
                  </p-datepicker>
                  <cx-form-errors [control]="form.get('toDate')"></cx-form-errors>
                </div>
              </div>
            }
          }
          @if (form.get('searchBy')?.value !== 'orderDate') {
            <div class="col-12 col-md-4 m-t-16">
              <div class="form-group">
                <span>{{ 'formSearch.enterValue' | cxTranslate }}</span>
                <input
                  type="text"
                  class="form-control"
                  formControlName="searchValue"
                  placeholder="{{ 'formSearch.valuesInclude' | cxTranslate }}"
                  (keydown.enter)="onEnter($event)"
                  />
                </div>
              </div>
            }
            <div class="col-12">
              <div class="form-group">
                <div class="form-check m-0">
                  <label class="m-0">
                    <input type="checkbox" name="onlyOpen" formControlName="onlyOpen" />
                    <span class="form-check-label">{{ 'return.form.showOnlyOpenReturns' | cxTranslate }}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="w-100 col-12 form-button-container p-l-0">
              <div class="col-12 col-md-8 form-note">
                <span>{{ 'formSearch.note' | cxTranslate }}</span>
              </div>
              <div class="col-md-2 d-flex form-button">
                <button class="btn btn-outline-primary btn-sm w-100" (click)="clearAll()">
                  {{ 'formSearch.clearAll' | cxTranslate }}
                </button>
              </div>
              <div class="col-md-2 d-flex form-button">
                <button type="submit" class="btn btn-primary btn-sm w-100">
                  <span class="material-symbols-outlined d-flex m-r-4"> search </span>
                  {{ 'formSearch.search' | cxTranslate }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      @if (!content.returnsRequest?.isPristine) {
        <div class="simple-card m-t-20">
          @if (!content.returnsRequest?.isLoading) {
            @if (content.returnsRequest?.returns?.length) {
              <table-pro [configs]="tableConfig">
                <div top-action-2>
                  <button type="button" class="btn btn-secondary btn-sm w-100" (click)="exportReturns()">
                    <span class="material-symbols-outlined d-flex m-r-4"> download </span>
                    {{ 'exportEntries.exportToExcel' | cxTranslate }}
                  </button>
                </div>
                <table class="table-responsive table-md">
                  <thead>
                    <tr>
                      <th>{{ 'return.table.header.order' | cxTranslate }}</th>
                      <th>{{ 'return.table.header.po' | cxTranslate }}</th>
                      <th>{{ 'return.table.header.line' | cxTranslate }}</th>
                      <th>{{ 'return.table.header.product' | cxTranslate }}</th>
                      <th>{{ 'return.table.header.date' | cxTranslate }}</th>
                      <th>{{ 'return.table.header.qtyAuthorized' | cxTranslate }}</th>
                      <th>{{ 'return.table.header.qtyAccepted' | cxTranslate }}</th>
                      <th>{{ 'return.table.header.sellingAmount' | cxTranslate }}</th>
                      <th>{{ 'return.table.header.amountCredit' | cxTranslate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (return of content.returnsRequest?.returns; track return) {
                      <tr>
                        <td [attr.data-value]="return.orderNumber">
                          <div class="d-flex">
                            <span class="responsive-title m-r-4"> {{ 'return.table.header.order' | cxTranslate }}:</span>
                            <a [routerLink]="['/my-account/return', return.orderUid]" class="text-underline">{{ return.orderNumber }}</a>
                          </div>
                        </td>
                        <td [attr.data-value]="return.poNumber">
                          <span class="responsive-title"> {{ 'return.table.header.po' | cxTranslate }}:</span>
                          {{ return.poNumber }}
                        </td>
                        <td [attr.data-value]="return.lineNumber">
                          <span class="responsive-title"> {{ 'return.table.header.line' | cxTranslate }}:</span>
                          {{ return.lineNumber }}
                        </td>
                        <td [attr.data-value]="return.product">
                          <span class="responsive-title"> {{ 'return.table.header.product' | cxTranslate }}:</span>
                          <div [innerHTML]="return.product"></div>
                        </td>
                        <td [attr.data-value]="return.orderDate">
                          <span class="responsive-title"> {{ 'return.table.header.date' | cxTranslate }}:</span>
                          {{ return.orderDate | date: 'MM/dd/yyyy' }}
                        </td>
                        <td [attr.data-value]="return.quantityOrdered">
                          <span class="responsive-title"> {{ 'return.table.header.qtyAuthorized' | cxTranslate }}:</span>
                          {{ return.quantityOrdered }}
                        </td>
                        <td [attr.data-value]="return.quantityAccepted">
                          <span class="responsive-title"> {{ 'return.table.header.qtyAccepted' | cxTranslate }}:</span>
                          {{ return.quantityAccepted }}
                        </td>
                        <td [attr.data-value]="return.sellingPrice?.value">
                          <span class="responsive-title"> {{ 'return.table.header.sellingAmount' | cxTranslate }}:</span>
                          {{ return.sellingPrice?.formattedValue }}
                        </td>
                        <td [attr.data-value]="return.total?.value">
                          <span class="responsive-title"> {{ 'return.table.header.amountCredit' | cxTranslate }}:</span>
                          {{ return.total?.formattedValue }}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </table-pro>
            } @else {
              <p class="text-center ff-bold m-0">{{ 'return.noReturnsAvailable' | cxTranslate }}</p>
            }
          } @else {
            <local-loader></local-loader>
          }
        </div>
      }
    }
